import styled from 'styled-components';
export var Mention = styled.a.withConfig({
  displayName: "Mention",
  componentId: "sc-7zw21k-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});
export var MentionNoLink = styled.span.withConfig({
  displayName: "Mention__MentionNoLink",
  componentId: "sc-7zw21k-1"
})(["color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.linkColor;
});